/**
 * Configuration object for the application.
 * @typedef {Object} AppConfig
 * @property {string} NODE_ENV - The environment mode of the application.
 * @property {string} NAME_KEY - The key name of the application.
 * @property {string} NAME_TITLE - The title of the application.
 * @property {string} API_BASE_URL - The base URL for API requests.
 * @property {string} RESUME_DOWNLOAD_URL - The URL for downloading resumes.
 * @property {string} DEFAULT_LANGUAGE - The default language of the application.
 * @property {string} IMAGE_URL - The URL for images used in the application.
 */

/**
 * Configuration object for the application.
 * Contains various environment-specific settings such as API URLs, language,
 * and image paths. These settings can be accessed throughout the application.
 * @type {AppConfig}
 */
const config = {
  NODE_ENV: process.env.NODE_ENV,
  NAME_KEY: process.env.REACT_APP_NAME_KEY || "App",
  NAME_TITLE: process.env.REACT_APP_NAME_TITLE || "app",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  DEFAULT_LANGUAGE: process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
  IMAGE_URL: process.env.REACT_APP_IMAGE_PATH,
};

export default config;
